<div class="msg-wrap">
  <header class="msg-head">
    <div class="msg-title-row">
      <span class="msg-title-icon"><i class="fa fa-user-plus"></i></span>
      <h1 class="msg-title">Connection requests</h1>
    </div>
    <p class="msg-subtitle">Galleries that have invited you to connect.</p>
  </header>

  @if (loaded && requests.length === 0) {
    <div class="msg-empty">
      <i class="fa fa-inbox"></i>
      <p>You have no pending connection requests.</p>
    </div>
  }

  <div class="msg-list">
    @for (r of requests; track r.Id) {
      <div class="msg-card">
        <div class="msg-logo">
          @if (r.GalleryImgUrl) { <img [src]="r.GalleryImgUrl" [alt]="r.Name"> }
          @else { <span>{{ (r.Name || 'G').charAt(0) }}</span> }
        </div>
        <div class="msg-info">
          <div class="msg-name">{{ r.Name }}</div>
          @if (r.Email) { <div class="msg-meta"><i class="fa fa-envelope"></i> {{ r.Email }}</div> }
          @if (r.PhoneNumber) { <div class="msg-meta"><i class="fa fa-phone"></i> {{ r.PhoneNumber }}</div> }
        </div>
        <div class="msg-actions">
          <button class="msg-btn msg-primary" (click)="accept(r)"><i class="fa fa-check"></i> Accept</button>
          <button class="msg-btn msg-ghost" (click)="decline(r)"><i class="fa fa-times"></i> Decline</button>
        </div>
      </div>
    }
  </div>
</div>
